import React from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  Alert,
  Box,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Stack,
  Switch,
} from '@mui/material';
import Button from '@mui/material/Button';
import { Controller, FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import TextInput from '../../components/Form/TextInput';
import { useCommonSlice } from '../../../store/commonSlice';
import { useSubmitMutation } from '../../../services/gmoOfferwallApi';
import useMessage from '../../../utils/customHooks/useMessage';
import {
  buildOfferwallPayload,
  createOfferwallDefaultValues,
  offerwallValidation,
  OfferwallFormValues,
} from './form';

function AddForm() {
  const { actions } = useCommonSlice();
  const dispatch = useDispatch();
  const methods = useForm<OfferwallFormValues>({
    resolver: yupResolver(offerwallValidation),
    defaultValues: createOfferwallDefaultValues(),
  });
  const errorMessages = Object.values(methods.formState.errors)
    .map(error => error?.message)
    .filter((message): message is string => !!message);
  const [createOfferwall, { isLoading, isSuccess, isError, error }] = useSubmitMutation();

  useMessage(isLoading, isError, isSuccess, error, true);

  const onSubmit: SubmitHandler<OfferwallFormValues> = values => {
    createOfferwall(buildOfferwallPayload(values));
  };
  const onInvalid = () => {
    toast.error('入力内容を確認してください。', {
      position: 'bottom-left',
    });
  };
  const handleFormSubmit = methods.handleSubmit(onSubmit, onInvalid);

  return (
    <DialogContent>
      <Box component={'form'} onSubmit={handleFormSubmit}>
        <FormProvider {...methods}>
          <Stack spacing={2}>
            {errorMessages.length > 0 ? (
              <Alert severity="error">
                {errorMessages.join(' / ')}
              </Alert>
            ) : null}
            <TextInput name={'url'} labelName={'URL'} showLabel={true} />
            <TextInput name={'icon_url'} labelName={'アイコンURL'} showLabel={true} />
            <TextInput name={'title'} labelName={'案件表示名'} showLabel={true} />
            <TextInput
              name={'requirements'}
              labelName={'達成条件'}
              showLabel={true}
              multiline={true}
              minRows={3}
            />
            <TextInput name={'point'} labelName={'ポイント'} showLabel={true} />
            <TextInput
              name={'stages'}
              labelName={'対象者'}
              showLabel={true}
              multiline={true}
              minRows={3}
            />
            <TextInput
              name={'bonus_point'}
              labelName={'ボーナスポイント'}
              showLabel={true}
              type={'number'}
            />
            <TextInput
              name={'notes'}
              labelName={'応募の仕方'}
              showLabel={true}
              multiline={true}
              minRows={3}
            />
            <TextInput
              name={'title_internal'}
              labelName={'案件名'}
              showLabel={true}
            />
            <TextInput name={'clid'} labelName={'CLID'} showLabel={true} />
            <TextInput name={'type'} labelName={'種別ID'} showLabel={true} />
            <TextInput name={'sort'} labelName={'順位'} showLabel={true} type={'number'} />
            <TextInput name={'category'} labelName={'カテゴリ'} showLabel={true} />
            <Controller
              name={'is_visible'}
              control={methods.control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Switch
                      checked={!!field.value}
                      onChange={(_, checked) => field.onChange(checked)}
                    />
                  }
                  label={`表示: ${field.value ? 'ON' : 'OFF'}`}
                />
              )}
            />
            <Controller
              name={'has_bonus_type'}
              control={methods.control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Switch
                      checked={!!field.value}
                      onChange={(_, checked) => field.onChange(checked)}
                    />
                  }
                  label={`ボーナスタイプ: ${field.value ? 'ON' : 'OFF'}`}
                />
              )}
            />
          </Stack>
        </FormProvider>
        <DialogActions className="dialogActionModal">
          <Button
            type={'button'}
            variant={'text'}
            onClick={() => dispatch(actions.closeModal())}
            className="btnModalCancel"
          >
            Cancel
          </Button>
          <Button
            type={'button'}
            variant={'text'}
            className="btnModalSubmit"
            disabled={isLoading}
            onClick={handleFormSubmit}
          >
            ADD
          </Button>
        </DialogActions>
      </Box>
    </DialogContent>
  );
}

export default AddForm;
